import { useAuth } from "@/auth/AuthContext";
import { LANG } from "@/lib/i18n";

// The app-wide language (saved to the account when signed in); switching reloads the page.
export const useLearnLang = () => {
  const { setLanguage } = useAuth();
  return [LANG, setLanguage];
};

// Renders **bold** segments without injecting HTML.
export const Rich = ({ text }) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") ? <b key={i}>{part.slice(2, -2)}</b> : part
  );

const OPTIONS = [
  { id: "en", label: "English" },
  { id: "es", label: "Español" },
];

export const LangToggle = ({ lang, onChange }) => (
  <div className="inline-flex rounded-full border border-[#E8ECEA] bg-white p-1" role="group" aria-label="Language / Idioma">
    {OPTIONS.map((o) => (
      <button key={o.id} type="button" onClick={() => onChange(o.id)} aria-pressed={lang === o.id}
        data-testid={`learn-lang-${o.id}`}
        className={`text-xs px-3 py-1.5 rounded-full transition-colors ${
          lang === o.id ? "bg-[#2F524A] text-white" : "text-[#1C201F] hover:bg-[#F4F7F6]"}`}>
        {o.label}
      </button>
    ))}
  </div>
);

// Single button for the top menu: shows the other language.
export const NavLangSwitch = ({ testid = "nav-lang-switch", className = "" }) => {
  const [lang, setLang] = useLearnLang();
  const next = lang === "es" ? "en" : "es";
  return (
    <button type="button" onClick={() => setLang(next)} data-testid={testid} lang={next}
      className={`text-sm text-[#2F524A] font-semibold hover:underline px-3 py-2 ${className}`}>
      {next === "es" ? "Español" : "English"}
    </button>
  );
};
